import { render, staticRenderFns } from "./new-resale.modal.vue?vue&type=template&id=02b501c8&scoped=true&"
import script from "./new-resale.modal.vue?vue&type=script&lang=js&"
export * from "./new-resale.modal.vue?vue&type=script&lang=js&"
import style0 from "./new-resale.modal.vue?vue&type=style&index=0&id=02b501c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b501c8",
  null
  
)

export default component.exports